const images = [
  {
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/c450ec3e7af2cc1bbbd1474556446aa2.jpeg",
    alt: "Technicien réparant une fenêtre PVC à Erstein, Bas-Rhin",
  },
  {
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/be6c1f97d5ea7df8bcbfbe3be74c7a73.jpeg",
    alt: "Réparation de mécanisme de fenêtre à Erstein, Bas-Rhin",
  },
  {
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/73131c375375b425d22a36886a752302.jpeg",
    alt: "Maison avec fenêtres réparées à Erstein, Bas-Rhin",
  },
];

export default function Gallery() {
  return (
    <section className="bg-[#EEF2F4] py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-3">
            Nos réalisations à Erstein
          </h2>
          <p className="text-[#243038] text-sm md:text-base">
            Quelques photos de nos interventions sur le terrain.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {images.map((img, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-[#D7E0E4] overflow-hidden"
            >
              <div className="h-48 md:h-56 overflow-hidden">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}